/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-file-preview',
    templateUrl: './file-preview.component.html',
    styleUrls: ['./file-preview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilePreviewComponent {

    @Input() extension: string;
    @Input() fileManagerOffline: boolean;

    constructor() {
    }

    getSvgFile(): string {
        if (this.fileManagerOffline) {
            return 'assets/img/thumbnail-error.svg';
        } else {
            return 'assets/img/thumbnail.svg';
        }
    }

    getClassIconText(): string {
        if (this.fileManagerOffline) {
            return 'text text-error';
        } else {
            return 'text';
        }
    }
}
